import React from 'react';
import { Layout, Row, Col, Typography, Divider } from 'antd';
import { 
  PhoneOutlined, 
  MailOutlined, 
  EnvironmentOutlined, 
  ClockCircleOutlined ,
  WarningFilled
} from '@ant-design/icons';
import './Footer.css';

const { Footer } = Layout;
const { Text, Link } = Typography;

const AppFooter = () => {
  return (
    <Footer className="app-footer">
      <Row gutter={[32, 32]}>
        <Col xs={24} md={8}>
          <h3>Prime Health Care Consultancy</h3>
          {/* <Text>
            Specialized consultants for Punjab Health Commission accreditation 
            and healthcare quality improvement.
          </Text><br /> */}
          <Text>
          <WarningFilled/>
            <strong> Note :</strong> We are not officially affiliated, partnered, or contracted with the Punjab Health Commission. Our role is purely consultative — to assist and advise healthcare facilities based on our expertise and understanding of PHC's published guidelines and regulations.
          </Text>
        </Col>
        <Col xs={24} md={8} >
          <h3>Quick Links</h3>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <a href="/">Home</a>
            <a href="/services">Services</a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <h3>Contact Us</h3>
          <p><PhoneOutlined /> +92 300 6617550</p>
          <p><MailOutlined /> primehealthcare.pk@gmail.com</p>
          {/* <p><EnvironmentOutlined /> 123 Healthcare St, Lahore, Pakistan</p> */}
          <p><ClockCircleOutlined /> Mon-Fri: 9:00 AM - 5:00 PM</p>
        </Col>
      </Row>
      <br /><br />
      <Divider style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
      <Row justify="center">
        <Col>
          <Text style={{ color: 'rgba(255,255,255,0.7)' }}>
            © {new Date().getFullYear()} Prime Health Care Consultancy. All rights reserved.
          </Text>
        </Col>
      </Row>
    </Footer>
  );
};

export default AppFooter;



